import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/sicurezza")({
  head: () => seoMeta({
    title: "Sicurezza dei dati: come LexAIPro protegge il tuo studio",
    description: "Zero retention, dati in EU, crittografia end-to-end. Tutte le misure di sicurezza di LexAIPro.",
    path: "/sicurezza",
  }),
  component: () => (
    <ContentPage
      eyebrow="Sicurezza"
      title="Sicurezza senza compromessi"
      lead="LexAIPro è progettato fin dall'inizio per la riservatezza richiesta dalla professione forense. Ogni livello - infrastruttura, dati, accesso - è hardenizzato."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Sicurezza",path:"/sicurezza"}]}
      sections={[
        { heading: "Pilastri", bullets: [
          "Zero retention sui documenti caricati",
          "I tuoi dati non addestrano i modelli",
          "Server e backup esclusivamente in UE",
          "Crittografia in transito (TLS 1.3) e a riposo (AES-256)",
          "Audit log completi accessibili al cliente",
        ] },
        { heading: "Continuità operativa", body: "Backup giornalieri cifrati, RPO 1h, RTO 4h, multi-AZ in EU." },
      ]}
      faq={[
        { q: "Posso firmare un DPA?", a: "Sì, forniamo un Data Processing Agreement standard ai clienti Studio." },
        { q: "Dove sono fisicamente i dati?", a: "In data center dell'Unione Europea (Francoforte, Dublino)." },
      ]}
      cta={{ label: "Richiedi il DPA", to: "/contatti" }}
      heroImage={pickContent(32)}
      updated="2026"
    />
  ),
});
